import { render, staticRenderFns } from "./inputCheckbox.vue?vue&type=template&id=27c4a559&"
import script from "./inputCheckbox.vue?vue&type=script&lang=js&"
export * from "./inputCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./inputCheckbox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports